import { Autocomplete, AutocompleteChangeReason, Stack, TextField } from '@mui/material';
import { useState} from 'react';
import { AddressItem, getLocations } from '../../services/GeocodeService';
import { useFromAddress, useToAddress, useRouteLocationActions } from '../../stores/RouteLocationStore';
import { BarrierPointMenu } from '../common/BarrierPointMenu';
import { ViaPointMenu } from '../common/ViapointMenu';

export interface ILocationSearchInputProps {
}

const defaultSearchResult: AddressItem[] = [];

export default function LocationSearchInput (props: ILocationSearchInputProps) {
    const [fromSearchResults, setFromSearchResults] = useState<AddressItem[]>(defaultSearchResult)
    const [toSearchResults, setToSearchResults] = useState<AddressItem[]>(defaultSearchResult)
    const { setFrom, setTo, clearFrom, clearTo } = useRouteLocationActions();;
    const fromAddress = useFromAddress();
    const toAddress = useToAddress();
    const debounce = (func: Function) => {
        let timer: any;
        return function (...args: any) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                func.apply(null, args);
            }, 750);
        };
      };

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
        if (event.target.value.length < 2) {
            return;
        }

        if (field === "from") {
            setFromSearchResults(await getLocations(event.target.value));
            return;
        }
        if (field === "to") {
            setToSearchResults(await getLocations(event.target.value));
        }
    }
    
    return (
        <Stack spacing={2}>
            <Autocomplete 
                id="from"
                disablePortal
                value={fromAddress}
                open={fromSearchResults.length > 0}
                onChange={(event: any, item: AddressItem | null, reason: AutocompleteChangeReason ) => {                                        
                    if (reason === "clear") {
                        clearFrom();
                        setFromSearchResults(defaultSearchResult);
                        return;
                    }                             
                    if (item !== null) {
                        setFrom(item);
                        setFromSearchResults(defaultSearchResult);
                    }
                }}                
                options={fromSearchResults.map((addressItem) => {return {name: addressItem!.name, location: addressItem!.location, order: 0}} )}
                renderInput={(params) => <TextField {...params} onChange={debounce((event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "from"))} label="Fra" />}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={ (option: AddressItem, value: AddressItem) => {; return option.name === value.name}}
            />

            <ViaPointMenu />

            <BarrierPointMenu />
            
            <Autocomplete 
                id="to"
                disablePortal
                value={toAddress}
                open={toSearchResults.length > 0}                
                onChange={(event: any, item: AddressItem | null, reason: AutocompleteChangeReason) => {                                        
                    if (reason === "clear") {
                        clearTo();
                        setToSearchResults(defaultSearchResult);
                        return;
                    }
                    if (item !== null) {
                        setTo(item);
                        setToSearchResults(defaultSearchResult);
                    }
                }}

                options={toSearchResults.map((addressItem) => { return {name: addressItem!.name, location: addressItem!.location, order: 0}})}
                renderInput={(params) => <TextField {...params} onChange={debounce((event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "to"))} label="Til" />}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={ (option: AddressItem, value: AddressItem) => {; return option.name === value.name}}
            />
        </Stack>
  );
}
